// The one source of overlay-type identity in the UI: the label a person reads, the order
// the galleries list them in, which types are hidden, and the kebab-case slug the API
// routes use. Slugs mirror OverlayTypeConverter.cs on the backend — keep them in step.
export const LABELS = {
  Roster: 'Roster',
  Starters: 'Starters',
  Scorebanner: 'Score Banner',
  Pausedbanner: 'Paused Banner',
  Scoreboard: 'Scoreboard',
  TeamShots: 'Team Shots',
  TeamComparison: 'Team Comparison',
  BestPerformance: 'Best Performance',
  Mvp: 'MVP',
}

export const SLUGS = {
  Roster: 'roster',
  Starters: 'starters',
  Scorebanner: 'scorebanner',
  Pausedbanner: 'pausedbanner',
  Scoreboard: 'scoreboard',
  TeamShots: 'team-shots',
  TeamComparison: 'team-comparison',
  BestPerformance: 'best-performance',
  Mvp: 'mvp',
}

export const ORDER = Object.keys(LABELS)

// Types the galleries do not offer. Team Shots is brandable and is NOT hidden: it is
// served only through our own streams, which the backend enforces, not the palette.
export const HIDDEN = new Set([])

const TYPE_BY_SLUG = Object.keys(SLUGS).reduce((acc, type) => {
  acc[SLUGS[type]] = type
  return acc
}, {})

// On Team Shots, variant selects which team's card the board serves (1 = home, 2 = away),
// picked by the backend from the requested side; types without an entry show a bare number.
export const VARIANT_LABELS = {
  TeamShots: { 1: 'Home Team', 2: 'Away Team' },
}

export const variantLabelForSlug = (slug, variant) =>
  VARIANT_LABELS[TYPE_BY_SLUG[slug]]?.[variant] ?? `Variant ${variant}`

// Types whose board can be branded to show both teams at once instead of one at a time.
// Mirrors OverlayFieldRegistry.SupportsTargetMode. Which way a given game's board is
// configured is the backend's answer (the card's requiresTeam flag), not ours — this set only
// says which types the question applies to, so the rack can label a Both board as such.
export const TARGET_MODE_TYPES = new Set(['Starters', 'Roster'])

export const supportsTargetModeSlug = (slug) => TARGET_MODE_TYPES.has(TYPE_BY_SLUG[slug])

export const isVisible = (type) => type in LABELS && !HIDDEN.has(type)
export const labelFor = (type) => LABELS[type] ?? type
export const labelForSlug = (slug) => LABELS[TYPE_BY_SLUG[slug]] ?? slug
